// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d6f0b0a9","667":"63f52260"}[chunkId] + ".chunk.js";
};